export enum ContemporaryReportType {
  Ytd = 0,
  Ltm = 1,
}
